import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=5d216be1"
import script from "./ActionCard.vue?vue&type=script&lang=js"
export * from "./ActionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports